import { Editor as TinyMCE } from '@tinymce/tinymce-react'
import { useRef } from 'react'
import { SITE_URL } from 'src/config/config'
import { Editor as TinyMCEEditor } from 'tinymce'

interface Props {
  initialValue: string | undefined
  onEditorChange: (content: string) => void
  maxLength?: number
  maxWord?: number
  borderRed?: string
  readOnly?: boolean
}

const Editor: React.FC<Props> = ({ initialValue, onEditorChange, maxLength, maxWord, borderRed, readOnly = false }) => {
  const editorRef = useRef<TinyMCEEditor | null>(null)

  const countWords = (content: string) => {
    return content.trim().split(/\s+/).length
  }

  const handleEditorChange = (content: string) => {
    if (maxLength && content.length > maxLength) {
      content = content.substring(0, maxLength)
    }
    if (maxWord && countWords(content) >= maxWord) {
      const words = content.trim().split(/\s+/).slice(0, maxWord)
      content = words.join(' ')
    }
    onEditorChange(content)
  }
  return (
    <div
      className={`border-2 ${borderRed ? borderRed : 'border-[#5C6E81]'} rounded-md overflow-hidden`}
      style={{ cursor: readOnly ? 'default' : 'text' }}
    >
      <TinyMCE
        tinymceScriptSrc={SITE_URL + '/tinymce/tinymce.min.js'}
        onInit={(evt, editor) => (editorRef.current = editor)}
        onEditorChange={handleEditorChange}
        value={initialValue}
        init={{
          height: readOnly ? 200 : 500,
          menubar: false,
          readonly: readOnly,
          plugins: [
            'advlist',
            'autolink',
            'lists',
            'link',
            'image',
            'charmap',
            'anchor',
            'searchreplace',
            'visualblocks',
            'code',
            'fullscreen',
            'insertdatetime',
            'media',
            'table',
            'preview',
            'help',
            'wordcount',
          ],
          toolbar: readOnly
            ? false
            : 'undo redo | blocks | ' +
              'bold italic forecolor | alignleft aligncenter ' +
              'alignright alignjustify | bullist numlist outdent indent | ' +
              'removeformat | help',
          content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
          setup: (editor) => {
            editor.on('init', () => {
              const editorContainer = editor.iframeElement?.closest('.tox-editor-container') as HTMLElement
              if (editorContainer) {
                editorContainer.style.border = 'none'
                editorContainer.style.borderRadius = '0'
                editorContainer.style.overflow = 'hidden'
              }

              const toolbar = editorContainer?.querySelector('.tox-toolbar__primary') as HTMLElement
              if (toolbar) {
                toolbar.style.borderBottom = '2px solid #5C6E81'
                toolbar.style.borderRadius = '0'
              }

              const iframe = editorContainer?.querySelector('iframe') as HTMLElement
              if (iframe) {
                iframe.style.border = 'none'
                iframe.style.borderRadius = '0'
              }

              const statusbar = editorContainer?.querySelector('.tox-statusbar') as HTMLElement
              if (statusbar) {
                statusbar.style.borderTop = '2px solid #5C6E81'
                statusbar.style.borderRadius = '0'
              }
            })
          },
          //statusbar: false,
        }}
      />
    </div>
  )
}

export default Editor
